import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'icon',
    props: {
        name: { type: String, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const svgUrl = computed(() => `/app/themes/burando/public/svg/sprite.symbol.svg#${props.name}`);
        const __returned__ = { props, svgUrl };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
